export const SITE_MONITORING_PROFILE_PREFERENCE_KEY = 'siteMonitoring.profile';
export const SITE_MONITORING_SITE_LIST_COLUMNS_PREFERENCE_KEY = 'siteMonitoring.siteListColumns';
export const SITE_MONITORING_KEY_METRICS_PREFERENCE_KEY = 'siteMonitoring.keyMetrics';
export const SITE_MONITORING_COLUMN_NAME_OVERRIDES_PREFERENCE_KEY = 'siteMonitoring.columnNameOverrides';
export const SITE_MONITORING_RECENT_SITES_PREFERENCE_KEY = 'siteMonitoring.recentSitesIds';
export const SITE_MONITORING_STARRED_SITES_PREFERENCE_KEY = 'siteMonitoring.starredSitesIds';
export const SITE_MONITORING_PREFERENCE_KEY = 'siteMonitoring.preference';
export const SITE_MONITORING_USER_PREFERENCES_KEY = 'siteMonitoring.userPreferences';
